import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Collaborator } from 'src/app/domain/collaborator';
import { CollaboratorDTO } from 'src/app/domain/dto/collaborator.dto';
import { Pagination } from 'src/app/domain/pagination';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CovenantWorkerService {
  url: string = `${environment.BASE_URL}/collaborators`;
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  });

  constructor(private http: HttpClient) {}

  getCollaborators(pagination: Pagination, collaborator?: Collaborator) {
    const params = {
      page: `${pagination.page ?? 1}`,
      per_page: `${pagination.per_page ?? 10}`,
      active: `${collaborator?.active ?? ''}`,
      name: `${collaborator?.name ?? ''}`,
      role: `${collaborator?.role ?? ''}`,
      whatsapp: `${collaborator?.whatsapp ?? ''}`,
    };

    return this.http.get<Collaborator>(this.url, {
      responseType: 'json',
      params: params,
    });
  }

  exportCollaborators(type: string, collaborator?: Collaborator) {
    const params = {
      active: `${collaborator?.active ?? ''}`,
      name: `${collaborator?.name ?? ''}`,
      role: `${collaborator?.role ?? ''}`,
      whatsapp: `${collaborator?.whatsapp ?? ''}`,
      type: type,
    };

    return this.http.get(`${this.url}/get/export`, {
      headers: this.httpHeaders,
      responseType: 'blob',
      params: params,
      observe: 'response',
    });
  }

  save(collaborator: Collaborator) {
    let dto = new CollaboratorDTO(collaborator);
    return this.http.post(this.url, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }

  update(collaborator: Collaborator) {
    let dto = new CollaboratorDTO(collaborator);
    console.log(JSON.stringify(dto));
    return this.http.put(
      `${this.url}/${collaborator.id}`,
      JSON.stringify(dto),
      {
        headers: this.httpHeaders,
        observe: 'response',
      }
    );
  }

  activeColaborattor(covenantId: number, collaboratorId: number) {
    return this.http.put(`${this.url}/${collaboratorId}/active`, null, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }

  deactiveColaborattor(covenantId: number, collaboratorId: number) {
    return this.http.put(`${this.url}/${collaboratorId}/deactive`, null, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }

  delete(collaboratorId: number) {
    return this.http.delete(`${this.url}/${collaboratorId}`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }

  resendActivationInstruction(collaboratorId: number) {
    return this.http.put(
      `${this.url}/${collaboratorId}/resend-activation-instructions`,
      {
        headers: this.httpHeaders,
        observe: 'response',
      }
    );
  }
}
